<script>
import Component from '~/sites/shop/pages/articleList/_slug'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/clanky/:slug',
      en: '/articles/:slug',
      sk: '/clanky/:slug',
    },
  },
}
</script>
